import { isString } from 'underscore';
import { include, endsWith } from 'underscore.string';

export const propertyIs = propertyName => error => error && (error.property === propertyName);
export const propertySuffixIs = propertySuffix =>
  error => error && endsWith(error.property, propertySuffix);
export const codeContains = text => error => error && include(error.code, text);
export const or = (f1, f2) => arg0 => f1(arg0) || f2(arg0);
export const and = (f1, f2) => arg0 => f1(arg0) && f2(arg0);

export const uniqueErrorTransform = (err = {}) => (isString(err) ?
  err :
  `${err.message}|${err.code}|${err.property}`);

export const errorMessage = campaignApiError => (campaignApiError &&
  (campaignApiError.isHtmlMessage ?
    { DangerousHtmlMessage: campaignApiError.message } :
    campaignApiError.message || campaignApiError.code || campaignApiError.toString())) || '';

export const isSchedulingError = or(codeContains('Schedule'), propertyIs('Scheduling'));
export const unmappedError = error => error && !error.property && !isSchedulingError(error);
